export function getTransText(key) {
    try {
        return (window === null || window === void 0 ? void 0 : window.getLocalLabel(key)) || '';
    }
    catch (e) {
        return '';
    }
}
